export default __webpack_public_path__ + "391390114102a5308646a6885ed22830.ttf";